import { formatFrAmount } from "../../utils/dataUtils";
import { isMobile } from "../../utils/utils";

type MgpGuarantyBarProps = {
    title: string;
    value1: number;
    value2: number;
    value3: number;
    handleOnMousseIn: (element: string) => void;
    handleOnMousseOut: () => void;
}

export default function MgpGuarantyBar({title, value1, value2, value3, handleOnMousseIn, handleOnMousseOut}: MgpGuarantyBarProps) {

    const total = value1 + value2 + value3;

    const calculateHeight = (value : number, total : number) => {
        const ratio = value / total;
        if (ratio == 0) {
            return 0.0;
        } else if (ratio < 0.01) {
            return 0.03;
        } else {
            return ratio;
        }
    }

    const height1 = calculateHeight(value1, total);
    const height2 = calculateHeight(value2, total);
    const height3 = 1 - height1 - height2 ;  

    return (
        <div className='guaranty-bar-container ta-center'>
            <div className='guaranty-bar mt-lg mb-md'>
                <div className='element rest bg-fushia' style={{height: `${height3*100}%`, display: value3 === 0 ? "none" : ""}}>
                    <p className="bar-label">{formatFrAmount(value3)}</p>
                </div>
                <div className='element mgp bg-bleu' style={{height: `${height2*100}%`, display: value2 === 0 ? "none" : ""}}>
                    <p className="bar-label">{formatFrAmount(value2)}</p>
                </div>
                <div className='element ameli bg-bleu-60' style={{height: `${height1*100}%`, display: value1 === 0 ? "none" : ""}}>
                    <p className="bar-label">{formatFrAmount(value1)}</p>
                </div>
            </div>
            <p className={`fz-xs bar-title`}>{title}</p>
        </div>
    );
} 